module.exports = __webpack_public_path__ + "img/main_slide_2.e92257d0.png";